// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"08c98332","787":"1199a6d1","853":"2b39dd32"}[chunkId] + ".chunk.js";
};